import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { useParams } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/pagination';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function TestimonialsSection() {
const [officialsData, setOfficialsData] = useState([]);
const { section, id } = useParams();
  useEffect(() => {
    (async () => await fetchOfficialsData())();
  }, [section, id]);

  async function fetchOfficialsData() {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=top_manag&status02[eq]=publish`
        ),
      ]);

      const [menueData] = responses;
      if (menueData.data.status === 200) {
        if (menueData.data.allData.length === 0) {
          setOfficialsData([]);
          console.log("Oops!", "Sorry! we did not find any Menue");
        } else {
          setOfficialsData(menueData.data.allData);
        }
      } else {
        console.log("Oops!", menueData.data.validation_error);
      }
    } catch (error) {
      console.log("Error", "There were no Data found!");
    }
  }

  if (officialsData.length === 0) {
    return null; // Nothing renders if there's no data
  }

  return (
    <section id="featured-official" className="featured-official-section position-relative text-white">
      {/* Background Image */}
      {/* <img
                                    loading="lazy"
                                    decoding="async"
        src="/assets/img/1.jpg"
        alt="Background"
        className="position-absolute top-0 start-0 w-100 h-100 bg-cover"
        style={{ objectFit: 'cover', zIndex: 0 }}
      /> */}

      {/* Overlay */}
      <div className="position-absolute top-0 start-0 w-100 h-100 bggreen" style={{ zIndex: 1 }}></div>

      {/* Foreground Content */}
      <div className="container-fluid px-0 position-relative" style={{ zIndex: 2 }}>
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 6000 }}
          loop={true}
          className="swiper-container"
        >
          {officialsData.map((official, index) => (
            <SwiperSlide key={index}>
              <div className="row align-items-center justify-content-center text-center text-lg-start gx-lg-3 gy-4" style={{ minHeight: '40vh' }}>
              
              {/* IMAGE */}
              <div className="col-lg-auto d-flex justify-content-center align-items-center p-3">
                <div className="image-frame">
                  {official.item01 &&
                      official.item01 !== "undefined" &&
                      official.item01 !== "null" &&
                      official.item01.trim() !== "" && (
                        <>
                          <img
                                    loading="lazy"
                                    decoding="async"
                            src={`${BACKEND_URL}upload/${official.item01}`}
                            alt={official.name || "Image"}
                            className="img-fluid"
                          />
                        </>
                      )}
                </div>
              </div>
              {/* INFO */}
              <div className="col-lg-auto d-flex justify-content-center align-items-center p-3">
                <div>
                  <h2 className="text-light">{official.item03b}</h2>
                  <h3 className="text-light mb-4 fs-4">{official.item03}</h3>
                  <h4 className="fst-italic text-white fs-5">{official.linker}</h4>
                </div>
              </div>

            </div>

            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default TestimonialsSection;
